import { useLanguage } from "@/contexts/LanguageContext";

// Formattazione budget
interface BudgetFormatOptions {
  showCurrency?: boolean;
  currencySymbol?: string;
}

export function formatBudget(
  budgetMin?: number | null,
  budgetMax?: number | null,
  options: BudgetFormatOptions = {}
): string {
  const { showCurrency = true, currencySymbol = "€" } = options;
  const prefix = showCurrency ? currencySymbol : "";
  
  if (budgetMin && budgetMax) {
    return `${prefix}${budgetMin.toLocaleString()} - ${prefix}${budgetMax.toLocaleString()}`;
  } else if (budgetMin) {
    return `${prefix}${budgetMin.toLocaleString()}+`;
  } else if (budgetMax) {
    return `Fino a ${prefix}${budgetMax.toLocaleString()}`;
  }
  return "Budget flessibile";
}

// Formattazione date di viaggio
interface DateFormatOptions {
  showYear?: boolean;
  locale?: string;
  fallbackText?: string;
}

export function formatTravelDates(
  startDate?: string | null,
  endDate?: string | null,
  options: DateFormatOptions = {}
): string {
  const { 
    showYear = true, 
    fallbackText = "Date flessibili" 
  } = options;
  const { language } = useLanguage();
  const locale = language ?? 'it-IT';

  if (startDate && endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    
    const startOptions: Intl.DateTimeFormatOptions = { 
      day: '2-digit', 
      month: 'short' 
    };
    
    const endOptions: Intl.DateTimeFormatOptions = { 
      day: '2-digit', 
      month: 'short' 
    };
    
    if (showYear) {
      endOptions.year = '2-digit';
    }
    
    return `${start.toLocaleDateString(locale, startOptions)} - ${end.toLocaleDateString(locale, endOptions)}`;
  }
  
  return fallbackText;
}

// Formattazione data di creazione
interface CreatedDateOptions {
  showYear?: boolean;
  locale?: string;
  format?: 'short' | 'long';
}

export function formatCreatedDate(
  dateString: string,
  options: CreatedDateOptions = {}
): string {
  const { 
    showYear = true, 
    locale = 'it-IT',
    format = 'short'
  } = options;

  const date = new Date(dateString);
  
  const dateOptions: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: format === 'short' ? 'short' : 'long'
  };
  
  if (showYear) {
    dateOptions.year = '2-digit';
  }
  
  return date.toLocaleDateString(locale, dateOptions);
}
